module.exports = __webpack_public_path__ + "static/media/grand_mother_and_friends_smiling-min.5d65dc43.gif";